<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
/* eslint-disable */
import 'element-ui/lib/theme-chalk/index.css';
export default {
  name: 'App'
}
</script>
<style lang="scss" scoped>
</style>
